<template>
    <v-container fluid style="margin-top: 0px; background-color:#f3f3f3;">
        <!--
        <v-layout row>
          <v-col xs12>  
            <h3 class="my-3">Prechekin {{$route.params.reservationid}}</h3>
            <v-btn color="warning" dark @click="refresh">Normal Button</v-btn>
         </v-flex>
         </v-layout>
         -->
         <v-row >

            <v-col cols="12" md="4" >
                <riepilogo-ospiti  :dati="$store.state.reservation.visitors" :mainguest="$store.state.reservation.mainguest" :rooms="$store.state.reservation.rooms" :labels="$store.state.labels" />
            </v-col>

            <v-col cols="12" md="8" >
                
                <div id="curr_element"/>
                <v-col  cols="12"  >
                    <mainguest  :datimainguest="$store.state.reservation.mainguest" :isprimary="true" :labels="$store.state.labels" :config="$store.state.settings" v-if="$store.state.reservation.mainguest.ismodified" ></mainguest>
                </v-col>
                
                <v-col  cols="12"  v-for="member in $store.state.reservation.visitors" :key="member.id">
                    <mainguest  :datimainguest="member" :isprimary="false" :labels="$store.state.labels" :config="$store.state.settings" v-if="member.ismodified" ></mainguest>
                </v-col> 

                
                <v-col  cols="12" >
                    <!--<istruzioni>  <istruzioni />        -->     
                    <seleziona-prossimo v-if="!$store.state.schedaospitevisibile"></seleziona-prossimo>     
                </v-col>   

                <v-col  cols="12" v-if="!$store.state.schedaospitevisibile && false">
                      <v-card class="text-xs-center" style="margin-top:10px">
                      <v-card-title>Servizi Extra</v-card-title>
                      <v-card-text>
                              <v-list-item-group
                        v-model="settings"
                        multiple
                        active-class=""
                      >
                        <v-list-item
                        v-for="n in 8" :key="n">
                          <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox >{{ active }}</v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>Extra {{n}}</v-list-item-title>
                              <v-list-item-subtitle>Notify me about updates to apps or games that I downloaded</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                              </v-list-item-group>
                      </v-card-text>
                    </v-card>  
                    
                    <v-card class="text-xs-center" style="margin-top:10px">
                      <v-card-title>Personalizza la tua camera</v-card-title>
                      <v-card-text>
                              <v-list-item-group
                        v-model="settings"
                        multiple
                        active-class=""
                      >
                        <v-list-item
                        v-for="n in 8" :key="n">
                          <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox >{{ active }}</v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title> Opzione Allestimento {{n}}</v-list-item-title>
                              <v-list-item-subtitle>Notify me about updates to apps or games that I downloaded</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                              </v-list-item-group>
                      </v-card-text>
                    </v-card> 
                </v-col>
               
 
                        <v-dialog
                            v-model="dialog_istruzioni"
                                width="500">  
                            <v-card>
                                <istruzioni :labels="$store.state.labels"></istruzioni>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        flat
                                        @click="dialog_istruzioni = false"
                                    >
                                        OK
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
 
                  
            </v-col>
        </v-row>


        
    <v-btn fab dark large color="orange" fixed bottom right @click="dialog_istruzioni=true">
      <v-icon dark>mdi-help</v-icon>
    </v-btn>
    </v-container>
</template>

<script>
/* eslint-disable no-prototype-builtins */
export default {
  data() {
    return {
        dialog: false,
        dialog_istruzioni: false,
        alldata: null,

    };
  },
  mounted: function() {
    
    var itemId = this.$route.params.reservationid;
    console.debug("ITEMID",itemId,this.$store.getters.reservationid)
      if(!itemId){
        itemId = this.$store.getters.reservationid;
      }
    var apiurl = this.$store.state.settings.apiurl;
    if(!this.$store.state.reservation.pmsid){
        this.setReservationid(apiurl, itemId);
    }
    
  },
    watch: {


    },
    computed:{
      istruzionivisibili () {
        var retval = true
        var indice =1
        for (const key in this.$store.state.reservation.visitors) {
            
            indice++;
            if (this.$store.state.reservation.visitors.hasOwnProperty(key)) {
                const element = this.$store.state.reservation.visitors[key];
                console.log('visitor->',indice);
                if(!element.iscompiled )
                {
                    retval = true;
                }
                else
                {
                    retval = false;
                    break;
                }
            }
        }
        retval = retval && !this.$store.state.reservation.mainguest.iscompiled
        console.log("capo modificato:",this.$store.state.reservation.mainguest.iscompiled);
        console.log("valuta istruzioni",retval);
        return retval;
      },
      modificheincorso(){
        var ret = false;
         
        for (const key in this.$store.state.reservation.visitors) {
            if (this.$store.state.reservation.visitors.hasOwnProperty(key)) {
                const element = this.$store.state.reservation.visitors[key];
                if(!element.ismodified && !element.iscompiled )
                {
                    ret = true;
                    break;
                }
            }
        }
            //ret = ret && !this.$store.state.reservation.mainguest.ismodified && !this.$store.state.reservation.mainguest.iscompiled;
            return ret;

      }

    },
  methods: {

    setReservationid(apiurl, id) {
     
     /*this.$http.get(apiurl + "/reservations/" + id, {}).then(resp => {
        console.log("RISP reservation->", resp);
        //Object.assign(this.alldata.reservation.mainguest, resp.body);
        this.$store.commit("setreservation", resp.body);
      });
    */
      this.$store.dispatch("setreservation", id);
      console.log("setreservationid", id);
    },
    refresh() {
    var itemId = this.$route.params.reservationid;
    console.log("UserProfile ready", itemId);
    var apiurl = this.$store.state.settings.apiurl;
    this.setReservationid(apiurl, itemId);
    },
  }
};
</script>
